export const snapshotsKeys = {
  all: ['snapshots'],
  list: () => [...snapshotsKeys.all, 'list'],
};
